import ServicesPage from './services-page'
export default ServicesPage
